import React, { useEffect, useState } from 'react'
import css from "../css/Refer.module.css"
import { Link } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2';
import Header from '../Components/Header';
import '../Components/Component-css/Common.css';
import {
  FaArrowLeft,
  FaCopy,
  FaCheckCircle,
  FaWhatsapp,
  FaWallet,
  FaGift,
  FaUserFriends,
  FaCoins,
  FaInfoCircle
} from 'react-icons/fa';




const Refer = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const [user, setUser] = useState()
  const Cashheader = () => {
    let access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.get(baseUrl + `me`, { headers })
      .then((res) => {
        setUser(res.data)
        // console.log(res.data);
        Allgames(res.data.referral_code)
      }).catch((e) => {
        alert(e.msg)
      })

  }

  const [cardData, setGame] = useState([])

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    await axios.get(baseUrl + `referral/code/${id}`, { headers })
      .then((res) => {
        setGame(res.data)
        console.log(res.data)

      })

  }

  const [WebSitesettings, setWebsiteSettings] = useState("");
  const fetchData = async () => {
    const response = await fetch(baseUrl + "settings/data");
    const data = await response.json();
    return setWebsiteSettings(data);
  }

  useEffect(() => {
    Cashheader()
    fetchData();
    //eslint-disable-next-line
  }, [])


  const copyCode = (e) => {
    // console.log(Game.Room_code);
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: 'center',
      icon: 'success',
      type: 'success',
      title: 'Refer Code Copied',
      showConfirmButton: false,
      timer: 1200,


    });

  }

  if (user === undefined) {
    return null
  }

  return (
    <div style={{ backgroundColor: "#0b1426", minHeight: "100vh", color: "#fff" }}>
      {/* Custom Styles */}
      <style>{`
        .leftContainer {
          background: #0b1426 !important;
          color: #fff;
          font-family: 'Poppins', sans-serif;
          min-height: 100vh;
          padding-bottom: 80px;
        }
        
        .refer-hero-card {
          background: linear-gradient(135deg, rgba(30, 50, 95, 0.8) 0%, rgba(15, 28, 55, 0.95) 100%);
          border: 1px solid rgba(96, 239, 255, 0.3);
          border-radius: 24px;
          padding: 28px 20px;
          text-align: center;
          margin-bottom: 24px;
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.55), inset 0 1px 1px rgba(255, 255, 255, 0.12);
          backdrop-filter: blur(20px);
        }

        .refer-gif-glow {
          filter: drop-shadow(0 0 20px rgba(96, 239, 255, 0.35));
          margin-bottom: 18px;
        }

        .premium-headline {
          font-size: 1.55rem;
          font-weight: 800;
          letter-spacing: 0.5px;
          background: linear-gradient(135deg, #60EFFF 0%, #00FF87 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 8px;
          filter: drop-shadow(0 2px 8px rgba(0, 255, 135, 0.2));
        }

        .premium-caption {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.92rem;
          margin-bottom: 0;
          font-weight: 300;
        }

        .earning-dashboard-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 24px;
        }

        .earning-glass-card {
          background: linear-gradient(135deg, rgba(30, 50, 95, 0.6) 0%, rgba(15, 28, 55, 0.85) 100%);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 20px;
          padding: 20px 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          text-align: center;
          min-height: 135px;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.08);
        }

        .earning-glass-card:hover {
          transform: translateY(-4px);
          background: linear-gradient(135deg, rgba(40, 65, 120, 0.75) 0%, rgba(20, 35, 70, 0.9) 100%);
          border-color: rgba(96, 239, 255, 0.45);
          box-shadow: 0 16px 35px rgba(96, 239, 255, 0.18), inset 0 1px 1px rgba(255, 255, 255, 0.15);
        }

        .earning-label {
          font-size: 0.72rem;
          color: rgba(255, 255, 255, 0.5);
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 600;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .earning-value-wallet {
          font-size: 1.45rem;
          font-weight: 800;
          color: #00ff87;
          margin-bottom: 12px;
          text-shadow: 0 0 10px rgba(0, 255, 135, 0.2);
        }

        .earning-value-total {
          font-size: 1.45rem;
          font-weight: 800;
          color: #FFE07D;
          margin-bottom: 12px;
          text-shadow: 0 0 10px rgba(255, 224, 125, 0.2);
        }

        .premium-redeem-btn {
          background: linear-gradient(135deg, #00FF87 0%, #60EFFF 100%);
          color: #0b1426 !important;
          font-weight: 700;
          font-size: 0.78rem;
          padding: 8px 18px;
          border-radius: 24px;
          border: none;
          outline: none;
          text-decoration: none !important;
          box-shadow: 0 4px 15px rgba(0, 255, 135, 0.4);
          transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
        }

        .premium-redeem-btn:hover {
          transform: scale(1.08);
          box-shadow: 0 6px 22px rgba(96, 239, 255, 0.6);
        }

        .refer-code-panel {
          background: linear-gradient(135deg, rgba(30, 50, 95, 0.65) 0%, rgba(15, 28, 55, 0.9) 100%);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 24px;
          padding: 24px 20px;
          margin-bottom: 24px;
          text-align: center;
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45), inset 0 1px 1px rgba(255, 255, 255, 0.1);
        }

        .refer-code-box {
          background: rgba(0, 0, 0, 0.25);
          border: 1px dashed rgba(255, 224, 125, 0.3);
          border-radius: 14px;
          padding: 14px;
          font-size: 1.3rem;
          font-weight: 800;
          letter-spacing: 2px;
          color: #FFE07D;
          cursor: pointer;
          transition: all 0.25s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin: 14px auto;
          max-width: 280px;
          box-shadow: inset 0 2px 6px rgba(0,0,0,0.3);
        }

        .refer-code-box:hover {
          background: rgba(255, 224, 125, 0.04);
          border-color: #FFE07D;
          box-shadow: inset 0 2px 6px rgba(0,0,0,0.3), 0 0 15px rgba(255, 224, 125, 0.15);
        }

        .total-refers-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.08);
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.85);
          margin-bottom: 18px;
        }

        .whatsapp-share-btn {
          width: 100%;
          background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
          color: white !important;
          border: none;
          outline: none;
          padding: 14px;
          border-radius: 14px;
          font-weight: 700;
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          text-decoration: none !important;
          box-shadow: 0 4px 20px rgba(56, 239, 125, 0.25);
          transition: all 0.25s ease;
        }

        .whatsapp-share-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(56, 239, 125, 0.45);
          filter: brightness(1.05);
        }

        .rules-panel {
          background: linear-gradient(135deg, rgba(30, 50, 95, 0.65) 0%, rgba(15, 28, 55, 0.9) 100%);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 24px;
          padding: 24px 20px;
          margin-bottom: 40px;
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45), inset 0 1px 1px rgba(255, 255, 255, 0.1);
        }

        .rules-title {
          font-size: 1.1rem;
          font-weight: 800;
          color: #fff;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .timeline-step {
          position: relative;
          padding-left: 32px;
          margin-bottom: 20px;
          text-align: left;
        }

        .timeline-step::before {
          content: '';
          position: absolute;
          left: 0;
          top: 3px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: linear-gradient(135deg, #60EFFF 0%, #00FF87 100%);
          box-shadow: 0 0 10px rgba(96, 239, 255, 0.6);
        }

        .timeline-step:not(:last-child)::after {
          content: '';
          position: absolute;
          left: 6px;
          top: 20px;
          bottom: -14px;
          width: 2px;
          background: rgba(255, 255, 255, 0.08);
        }

        .step-title {
          font-size: 0.88rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 4px;
          letter-spacing: 0.3px;
        }

        .step-desc {
          font-size: 0.78rem;
          color: rgba(255, 255, 255, 0.55);
          line-height: 1.45;
        }

        .example-box {
          background: rgba(96, 239, 255, 0.03);
          border: 1px solid rgba(96, 239, 255, 0.12);
          border-radius: 16px;
          padding: 14px;
          margin-top: 20px;
          font-size: 0.8rem;
          line-height: 1.5;
          text-align: left;
        }
      `}</style>

      <Header user={user} />

      <div className="leftContainer px-3 pt-4">
        {/* Hero Section */}
        <div className="refer-hero-card">
          <picture className="refer-gif-glow">
            <img
              alt="refer icon"
              width="90px"
              src={process.env.PUBLIC_URL + 'Images/refer/refer.gif'}
              className="img-fluid"
            />
          </picture>
          <div className="premium-headline">Earn Unlimited Cash 🥳</div>
          <p className="premium-caption">Refer your friends and get lifetime benefits!</p>
        </div>

        {/* Earning Grid */}
        <div className="earning-dashboard-grid">
          <div className="earning-glass-card">
            <div className="earning-label">
              <FaWallet size={12} style={{ color: "#00FF87" }} />
              <span>Current</span>
            </div>
            <div className="earning-value-wallet">₹{user.referral_wallet}</div>
            <Link className="premium-redeem-btn" to="/Redeem">
              Redeem
            </Link>
          </div>

          <div className="earning-glass-card">
            <div className="earning-label">
              <FaCoins size={12} style={{ color: "#FFE07D" }} />
              <span>Total Earned</span>
            </div>
            <div className="earning-value-total">₹{user.referral_earning}</div>
            <div style={{ height: "33px" }}></div> {/* Spacer to match the Redeem button height */}
          </div>
        </div>

        {/* Code Box section */}
        <div className="refer-code-panel">
          <div className="total-refers-badge">
            <FaUserFriends size={12} style={{ color: "#60EFFF" }} />
            <span>Total Refers: <strong>{cardData || 0}</strong></span>
          </div>

          <div className="text-white-50 small mb-1" style={{ fontSize: "0.72rem", letterSpacing: "0.5px", textTransform: "uppercase" }}>
            Tap to Copy Refer Code
          </div>
          <div className="refer-code-box" onClick={(e) => copyCode(e)}>
            <span>{user.referral_code}</span>
            <FaCopy size={14} style={{ color: "rgba(255, 224, 125, 0.7)" }} />
          </div>

          {/* WhatsApp share */}
          <div className="mt-3">
            <a
              href={`whatsapp://send?text=Play Ludo and earn ₹10000 daily. ${(WebSitesettings) ? WebSitesettings.CompanyWebsite : ''}/login/${user.referral_code} Register Now, My refer code is ${user.referral_code}.`}
              className="whatsapp-share-btn"
            >
              <FaWhatsapp size={18} />
              <span>Share on WhatsApp</span>
            </a>
          </div>
        </div>

        {/* Rules section */}
        <div className="rules-panel">
          <div className="rules-title">
            <FaInfoCircle size={14} style={{ color: "#60EFFF" }} />
            <span>Refer & Earn Rules</span>
          </div>

          <div className="timeline-step">
            <div className="step-title">1. Send Invitation</div>
            <div className="step-desc">Share your unique referral link or code with your friends.</div>
          </div>

          <div className="timeline-step">
            <div className="step-title">2. Friend Joins & Plays</div>
            <div className="step-desc">Your friend signs up using your link and plays cash battles on the portal.</div>
          </div>

          <div className="timeline-step">
            <div className="step-title">3. Earn Lifetime Commission</div>
            <div className="step-desc">You get a solid <strong style={{ color: "#00FF87" }}>2% Commission</strong> instantly on all of your referral's winnings!</div>
          </div>

          <div className="example-box text-white-50">
            <strong style={{ color: "#FFE07D", fontSize: "0.82rem" }} className="d-block mb-1">💡 Example Scenario:</strong>
            If your referral plays a battle for <strong style={{ color: "#fff" }}>₹10,000 Cash</strong> and wins, you get <strong style={{ color: "#00FF87" }}>₹300 Cash</strong> credited directly into your wallet with zero effort!
          </div>
        </div>
      </div>
    </div>
  );
}





export default Refer
